export default "__VITE_ASSET__71c612eb__"